module.exports = __webpack_public_path__ + "img/payment-method.529dcd10.png";